import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnotations = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1.062,7.92l13.962,0l-13.962,0Z",
				style: { fillRule: "nonzero" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.062,12.971l8.956,0l-8.956,0Z",
				style: { fillRule: "nonzero" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.062,7.92l13.962,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.6px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.062,12.971l8.956,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.6px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.062,2.868l13.962,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.6px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.843,19.676l0,2.112l2.274,0l6.476,-6.613l-2.182,-2.204l-6.567,6.705Z",
				style: {
					fillRule: "nonzero",
					fill: "currentColor"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.651,11.639l2.182,2.136l0.966,-0.966c0.303,-0.303 0.303,-0.795 0,-1.099l-1.023,-1.023c-0.295,-0.295 -0.772,-0.304 -1.078,-0.02l-1.048,0.972Z",
				style: {
					fillRule: "nonzero",
					fill: "currentColor"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.062,2.867l13.962,0l-13.962,0Z",
				style: { fillRule: "nonzero" }
			})
		]
	})
});
export default SvgAnnotations;
